import { render, staticRenderFns } from "./DevPageKD4.vue?vue&type=template&id=60950b34&scoped=true"
import script from "./DevPageKD4.vue?vue&type=script&lang=js"
export * from "./DevPageKD4.vue?vue&type=script&lang=js"
import style0 from "./DevPageKD4.vue?vue&type=style&index=0&id=60950b34&prod&lang=css"
import style1 from "./DevPageKD4.vue?vue&type=style&index=1&id=60950b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60950b34",
  null
  
)

export default component.exports